<p class="text-grey font-sans font-medium text-sm" data-cy="text">
  {{ (currentIndex$ | async) + 1 }}/{{ stepOrder.length }} {{ progressBarText | translate }}
</p>
